const React = require('react');
const delay = require('mn-utils/delay');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const isInvalidStringLength = require('mn-utils/isInvalidStringLength');
const validatePassword = require('../../../../../utils/validatePassword');
const withState = require('../../../../../utils/withState');
const {
  apiAuthPasswordSet,
} = require('../../../../../api/merchant/account');
const {
  openPopupInfo,
} = require('../../../../../emitters/popup');
const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const TextFieldPassword = require('../../../../dumb/TextField/PasswordB');
const Button = require('../../../../dumb/Button/Accept');
const {account$} = require("../../../../../emitters/account");


module.exports = withState((setState, self) => {
  const changeProvider = changeProviderProvider(setState);
  const handleChangeCurrentPassword = changeProvider('currentPassword');
  const handleChangeNewPassword = changeProvider('newPassword');
  const handleChangeRepeatPassword = changeProvider('repeatPassword');
  const handleToggleCurrentPassword = handleToggleVisibleProvider('visibleCurrentPassword');
  const handleToggleNewPassword = handleToggleVisibleProvider('visibleNewPassword');
  const handleToggleRepeatPassword = handleToggleVisibleProvider('visibleRepeatPassword');
  let _changed = false;

  function handleToggleVisibleProvider(key) {
    return () => {
      setState({
        [key]: !self.state[key],
      });
    };
  }

  function update() {
    delay(() => {
      self.props.onChange({
        changed: _changed,
        saved: self.state.saved,
      });
    });
  }

  self.state = {
    saved: false,
    lastPassword: '',
  };


  return (state, props) => {
    function saveData() {
      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }
      setState({
        loading: true,
      });

      const {name, login} = state.account;

      const params = {
        name,
        login,
        old_password: currentPassword,
        password: newPassword,
      }

      apiAuthPasswordSet({
        name,
        login,
        old_password: currentPassword,
        password: newPassword,
      }).finally((error) => {
        setState({
          loading: false,
          saved: !error,
          lastPassword: error ? '' : newPassword,
        });
        error || openPopupInfo([
          'Password has been changed',
        ]);
      });
    }

    const currentPassword = state.currentPassword || '';
    const newPassword = state.newPassword || '';
    const repeatPassword = state.repeatPassword || '';

    const filled = !!(currentPassword || newPassword || repeatPassword);


    const invalidNewPasswordChars = !validatePassword(newPassword);
    const invalidNewPasswordLength = isInvalidStringLength(newPassword, 8);
    const invalidNewPasswordWeak = !validatePassword.week(newPassword);

    const invalidCurrentPassword = !currentPassword;
    const invalidNewPassword = invalidNewPasswordChars
      || invalidNewPasswordLength
      || invalidNewPasswordWeak;
    const invalidRepeatPassword = !repeatPassword || repeatPassword !== newPassword;

    const clicked = !!state.clicked;

    const disabled = invalidCurrentPassword
      || invalidNewPassword
      || invalidRepeatPassword;


    const changed = state.lastPassword !== newPassword;
    _changed === changed || update(_changed = changed);


    return (
      <WrapperWithLoading
        className={props.className || ''}
        loading={state.loading}
      >
        <div className="cfx mh-28 (w1/2|w@m|ph28|lt)>1">
          <div>
            <TextFieldPassword
              label="Current password"
              value={currentPassword}
              onChange={handleChangeCurrentPassword}
              error={clicked && invalidCurrentPassword}
              visible={state.visibleCurrentPassword}
              onClickVisible={handleToggleCurrentPassword}
            />
            <div className="fw4 f12 lh18 lts0em tl mt27">
              <b className="fw7">Note:</b> Make sure your new password is strong enough.
              At least six characters and minimum one number.
            </div>
          </div>
          <div className="mt27@m">
            <TextFieldPassword
              label="New password"
              value={newPassword}
              onChange={handleChangeNewPassword}
              error={clicked && invalidNewPassword}
              visible={state.visibleNewPassword}
              onClickVisible={handleToggleNewPassword}
              helperText={
                invalidNewPasswordChars
                  ? 'Password must contain Latin letters, numbers and symbols'
                  : (
                    invalidNewPasswordLength
                      ? 'Password must contain at least 8 characters'
                      : 'Password too weak'
                  )
              }
            />
            <TextFieldPassword
              className="mt27"
              label="Repeat new password"
              value={repeatPassword}
              onChange={handleChangeRepeatPassword}
              error={clicked && invalidRepeatPassword}
              visible={state.visibleRepeatPassword}
              onClickVisible={handleToggleRepeatPassword}
            />
            <Button
              className="mt40"
              disabled={filled ? disabled && clicked : true}
              onClick={saveData}
            >Change</Button>
          </div>
        </div>
      </WrapperWithLoading>
    );
  };
}, {
  account: account$,
});
